import { useState, useEffect } from 'react';
import axios from 'axios';
import './Country.css';

const SERVER_URL = process.env.SERVER_URL || 'expater-server.vercel.app';

const Country = ({ countryId, countryName, onBack }) => {
  const [visas, setVisas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVisas = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://${SERVER_URL}/api/get-visas/${countryId}`);
        setVisas(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching visas:', err);
        setError('Failed to load visa information. Please try again later.');
        setLoading(false);
      }
    };

    fetchVisas();
  }, [countryId]);

  if (loading) return <div className="loading">Loading visa information...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="country-detail">
      <button className="back-button" onClick={onBack}>← Back to Countries</button>
      <h2>{countryName} Visa Options</h2>
      
      {visas.length === 0 ? (
        <p className="no-visas">No visa information available for this country yet.</p>
      ) : (
        <div className="visa-list">
          {visas.map(visa => (
            <div key={visa.id} className="visa-card">
              <h3>{visa.name}</h3>
              <p className="visa-description">{visa.description}</p>
              
              <div className="visa-details">
                {visa.duration && (
                  <div className="visa-detail">
                    <span className="detail-label">Duration:</span> {visa.duration}
                  </div>
                )}
                {visa.processing_time && (
                  <div className="visa-detail">
                    <span className="detail-label">Processing Time:</span> {visa.processing_time}
                  </div>
                )}
                {visa.cost && (
                  <div className="visa-detail">
                    <span className="detail-label">Cost:</span> {visa.cost}
                  </div>
                )}
              </div>
              
              {visa.requirements && visa.requirements.length > 0 && visa.requirements[0] !== null && (
                <div className="requirements">
                  <h4>Requirements:</h4>
                  <ul>
                    {visa.requirements.map((requirement, index) => (
                      <li key={index}>{requirement}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Country;